window.onscroll = function() {
    scrollFunction();
};

function scrollFunction() {
    // Get the header element
    var header = document.getElementById("header");
    // Define the scroll amount (e.g., 50 pixels) after which the logo should shrink
    var scrollThreshold = 35; 

    // Check if the user has scrolled past the threshold
    if (document.body.scrollTop > scrollThreshold || document.documentElement.scrollTop > scrollThreshold) {
        header.classList.add("shrink"); // Add the 'shrink' class
    } else {
        header.classList.remove("shrink"); // Remove the 'shrink' class (back to original size)
    }
}